module.exports = __webpack_public_path__ + "img/py.5badf078.png";